const YOSPACE_ERROR_BASE = 0x0500;
export const YospaceErrorCodes = Object.freeze({
  /**
   * Indicates that the Yospace session initialization failed
   */
  SESSION_INIT_FAILURE: YOSPACE_ERROR_BASE + 0x01,

  /**
   * Indicate that the yospace session failed during playback
   */
  PLAYBACK_SESSION_FAILURE: YOSPACE_ERROR_BASE + 0x03,
});
